import { Component } from '@angular/core';

@Component({
  selector: 'app-operations-card-loader',
  templateUrl: './operation-card-loader.component.html'
})
export class OperationCardLoaderComponent {
}
